import React, { useState, useEffect } from 'react';
import Modal from '../../components/Modal';
import { currencyChange, parseCurrencyToNumber } from '../../utils/masks';

export default function CustomSaleItemModal({ isOpen, onClose, onConfirm }) {
  const [description, setDescription] = useState('Venda avulsa');
  const [amount, setAmount] = useState('');

  useEffect(() => {
    if (isOpen) {
      setDescription('Venda avulsa');
      setAmount('');
    }
  }, [isOpen]);

  const amountValid = parseCurrencyToNumber(amount) > 0;

  const handleConfirm = () => {
    if (!amountValid) return;
    onConfirm(description.trim() || 'Venda avulsa', amount);
    onClose();
  };

  const title = (
    <div style={{
      background: 'linear-gradient(135deg, #f29205 0%, #ff6b35 100%)',
      margin: '-24px -24px 0 -24px',
      padding: '24px',
      borderRadius: '12px 12px 0 0',
      borderBottom: '2px solid rgba(255, 255, 255, 0.1)'
    }}>
      <h2 style={{
        margin: '0',
        color: '#ffffff',
        fontSize: '24px',
        fontWeight: '700',
        display: 'flex',
        alignItems: 'center',
        gap: '12px'
      }}>
        <i className="fas fa-money-bill-wave" style={{ fontSize: '22px' }} />
        Venda Avulsa
      </h2>
      <p style={{
        margin: '8px 0 0 0',
        color: 'rgba(255, 255, 255, 0.85)',
        fontSize: '13px',
        fontWeight: '500'
      }}>
        Adicione um item ao carrinho sem vincular a um produto do estoque
      </p>
    </div>
  );

  const footer = (
    <>
      <button
        onClick={onClose}
        type="button"
        style={{
          background: 'rgba(255, 255, 255, 0.08)',
          border: '1px solid rgba(255, 255, 255, 0.15)',
          color: '#b0b0b0',
          padding: '10px 24px',
          borderRadius: '8px',
          fontWeight: '600',
          fontSize: '14px',
          cursor: 'pointer',
          transition: 'all 0.3s ease'
        }}
        onMouseEnter={(e) => {
          e.target.style.background = 'rgba(255, 255, 255, 0.12)';
          e.target.style.color = '#d0d0d0';
        }}
        onMouseLeave={(e) => {
          e.target.style.background = 'rgba(255, 255, 255, 0.08)';
          e.target.style.color = '#b0b0b0';
        }}
      >
        Cancelar
      </button>
      <button
        onClick={handleConfirm}
        type="button"
        disabled={!amountValid}
        style={{
          background: amountValid ? 'linear-gradient(135deg, #f29205 0%, #ff6b35 100%)' : 'rgba(255, 255, 255, 0.1)',
          border: 'none',
          color: amountValid ? '#ffffff' : 'rgba(255, 255, 255, 0.4)',
          padding: '10px 24px',
          borderRadius: '8px',
          fontWeight: '600',
          fontSize: '14px',
          cursor: amountValid ? 'pointer' : 'not-allowed',
          transition: 'all 0.3s ease',
          boxShadow: amountValid ? '0 4px 15px rgba(242, 146, 5, 0.3)' : 'none'
        }}
        onMouseEnter={(e) => {
          if (!amountValid) return;
          e.target.style.transform = 'translateY(-2px)';
          e.target.style.boxShadow = '0 6px 20px rgba(242, 146, 5, 0.4)';
        }}
        onMouseLeave={(e) => {
          if (!amountValid) return;
          e.target.style.transform = 'translateY(0)';
          e.target.style.boxShadow = '0 4px 15px rgba(242, 146, 5, 0.3)';
        }}
      >
        Adicionar
      </button>
    </>
  );

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={title} footer={footer}>
      <div style={{ marginBottom: '20px' }}>
        <label style={{
          display: 'block',
          marginBottom: '8px',
          color: '#e0e0e0',
          fontSize: '14px',
          fontWeight: '600'
        }}>
          Descrição
        </label>
        <input
          type="text"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          placeholder="Ex: Venda avulsa, Serviço extra..."
          style={{
            width: '100%',
            padding: '12px',
            borderRadius: '8px',
            border: '1px solid rgba(242, 146, 5, 0.3)',
            background: 'rgba(255, 255, 255, 0.05)',
            color: '#ffffff',
            fontSize: '14px',
            boxSizing: 'border-box'
          }}
        />
      </div>

      <div>
        <label style={{
          display: 'block',
          marginBottom: '8px',
          color: '#e0e0e0',
          fontSize: '14px',
          fontWeight: '600'
        }}>
          Valor
        </label>
        <input
          type="text"
          inputMode="numeric"
          value={amount}
          onChange={(e) => setAmount(currencyChange(e.target.value, 'R$'))}
          placeholder="R$ 0,00"
          style={{
            width: '100%',
            padding: '12px',
            borderRadius: '8px',
            border: '1px solid rgba(242, 146, 5, 0.3)',
            background: 'rgba(255, 255, 255, 0.05)',
            color: '#ffffff',
            fontSize: '14px',
            boxSizing: 'border-box'
          }}
        />
      </div>
    </Modal>
  );
}
